import { privateAxios } from "../../../config/apiConfig";
import { getAllBanner } from "../Banner/Action";
import { GET_ALL_OFFERS_REQUEST, GET_ALL_OFFERS_SUCCESS, GET_ALL_OFFERS_FAILURE, GET_OFFERS_FAILURE, GET_OFFERS_REQUEST, GET_OFFERS_SUCCESS, CREATE_SPECIAL_OFFERS_REQUEST, CREATE_SPECIAL_OFFERS_FAILURE, GET_SPECIAL_OFFERS_REQUEST, GET_SPECIAL_OFFERS_FAILURE, GET_SPECIAL_OFFERS_SUCCESS, GET_OFFERS_BY_VENDOR_FAILURE, GET_OFFERS_BY_VENDOR_REQUEST, GET_OFFERS_BY_VENDOR_SUCCESS } from "./ActionType";
import { toast } from "react-toastify";


export const createSpecialOffer = (offerData) => async (dispatch) => {
    dispatch({ type: CREATE_SPECIAL_OFFERS_REQUEST })
    try {
        const { data } = await privateAxios.post(`admin/offer`, offerData);
        if (data.status === "SUCCESS") {
            dispatch(getSpecialOffer());
            dispatch(getAllBanner());
            toast.success(data.response || "Offer added successfully !!")
        }
    } catch (error) {
        if (error.response.data.status === "FAIL") {
            toast.error(error.response.data.response);
        }
        dispatch({ type: CREATE_SPECIAL_OFFERS_FAILURE, payload: error.message })
    }
}

export const getSpecialOffer = () => async (dispatch) => {
    dispatch({ type: GET_SPECIAL_OFFERS_REQUEST })
    try {
        const { data } = await privateAxios.get(`admin/offers/special`);
        dispatch({ type: GET_SPECIAL_OFFERS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_SPECIAL_OFFERS_FAILURE, payload: error.message })
    }
}

export const getOffers = () => async (dispatch) => {
    dispatch({ type: GET_ALL_OFFERS_REQUEST })
    try {
        const { data } = await privateAxios.get(`admin/offers/product`);
        dispatch({ type: GET_ALL_OFFERS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_ALL_OFFERS_FAILURE, payload: error.message })
    }
}

export const getOffersByBrand = (brandId) => async (dispatch) => {
    dispatch({ type: GET_OFFERS_REQUEST })
    try {
        const { data } = await privateAxios.get(`admin/offers/brand/${brandId}`);
        dispatch({ type: GET_OFFERS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_OFFERS_FAILURE, payload: error.message })
    }
}

export const getOffersByVendor = (vendorId) => async (dispatch) => {
    dispatch({ type: GET_OFFERS_BY_VENDOR_REQUEST })
    try {
        const { data } = await privateAxios.get(`admin/offers/vendor/${vendorId}`);
        dispatch({ type: GET_OFFERS_BY_VENDOR_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: GET_OFFERS_BY_VENDOR_FAILURE, payload: error.message })
    }
}
